// extracted by mini-css-extract-plugin
export default {"title":"delete_title__gz0IE","buttonPart":"delete_buttonPart__IvXfW","buttonCancel":"delete_buttonCancel__XelgI","buttonDelete":"delete_buttonDelete__ciVwG"};